


// import React, { useState } from "react";
// import React from 'react';
import {Link} from 'react-router-dom';
import "./loginmodal.css";
// import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png'
import AgendexBrandLogo from '../../Assets/agendex/agendexLogoResponsivo'

function Login(){
    var ano = new Date().getFullYear();
    return (
            <div className="fade-in">
                <div className="container py-5">
                    {/* LOGO CENTRALIZADO SUPERIOR */}
                    <div className="d-flex justify-content-center mb-5 fade-in">
                        <div className="bg-white px-4 py-3 rounded-4 shadow-sm">
                            <AgendexBrandLogo subtitle="ACESSAR CONTA" />
                        </div>
                    </div>
    
                    <div className="row justify-content-center align-items-stretch g-4" style={{ minHeight: '480px' }}>
                        
                        {/* LADO ESQUERDO: LOGIN CLIENTE (CONSUMIDOR) */}
                        <div className="col-md-6 d-flex">
                            <div className="card w-100 border-0 rounded-4 text-white shadow-lg overflow-hidden d-flex flex-column justify-content-between p-4 p-md-5" 
                                style={{ backgroundColor: '#212529', backgroundImage: 'linear-gradient(145deg, #212529, #2c3034)' }}>
                                <div>
                                    <span className="badge bg-primary px-3 py-2 rounded-pill mb-3 text-uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '1px' }}>Consumidor</span>
                                    <h2 className="display-6 fw-bold mb-3">Login Cliente</h2>
                                    <p className="text-muted mb-4">
                                        Acesse para agendar serviços com seus profissionais favoritos de beleza, petshop, estética e muito mais.
                                    </p>
                                </div>
                                <div className="mt-4">
                                    {/* <button 
                                        onClick={() => onNavigate('cliente')} 
                                        className="btn btn-light btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale"
                                        style={{ color: '#212529' }}
                                    >
                                        Entrar como Cliente →
                                    </button> */}
                                    <Link to="/app/login/cliente" 
                                        className="btn btn-light btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale"
                                        style={{ textDecoration: 'none' }} 
                                        type="button" 
                                        id="logincliente" 
                                        name="logincliente" 
                                        value="Login">Entrar como Cliente →
                                    </Link>                                    
                                </div>
                            </div>
                        </div>

                        {/* LADO DIREITO: LOGIN PRESTADOR (EMPRESA) */}
                        <div className="col-md-6 d-flex">
                            <div className="card w-100 border-0 rounded-4 text-white shadow-lg overflow-hidden d-flex flex-column justify-content-between p-4 p-md-5" 
                                style={{ backgroundColor: '#f05837', backgroundImage: 'linear-gradient(145deg, #f05837, #d94320)' }}>
                                <div className="position-relative">
                                    {/* Logo do Agendex no canto superior do prestador */}
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <span className="badge bg-dark bg-opacity-25 px-3 py-2 rounded-pill text-uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '1px' }}>Profissional / SaaS</span>
                                        {/* <div className="bg-white rounded-circle p-2 d-inline-flex shadow-sm" style={{ marginTop: '-10px' }}> */}
                                            {/* <AgendexLogo size={32} /> */}
                                            {/* <img src={AgendexLogo} size={32} alt="Agendex. All-in-one. Tudo num só lugar!"/> */}
                                        {/* </div> */}
                                    </div>
                                    <h2 className="display-6 fw-bold mb-3">Login Prestador</h2>
                                    <p className="text-white text-opacity-75 mb-4">
                                        Gerencie seu salão, barbearia, clínica ou petshop. Organize horários de colaboradores, envie alertas e fature mais.
                                    </p>
                                </div>
                                <div className="mt-4">
                                    {/* <button 
                                        onClick={() => onNavigate('prestador')} 
                                        className="btn btn-white btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale"
                                        style={{ backgroundColor: '#ffffff', color: '#f05837', border: 'none' }}
                                    >
                                        Entrar como Profissional →
                                    </button> */}
                                    <Link to="/app/login/prestador" 
                                        className="btn btn-white btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale"
                                        style={{ backgroundColor: '#ffffff', color: '#f05837', border: 'none' }}
                                        type="button" 
                                        id="loginprestador" 
                                        name="loginprestador" 
                                        value="Login">Entrar como Profissional →
                                    </Link>

                                </div>
                            </div>
                        </div>

                    </div>

                    {/* LINKS ÚTEIS E ESQUECEU A SENHA */}
                    <div className="text-center mt-5">
                        {/* <button 
                            onClick={() => onNavigate('resetsenha')} 
                            className="btn btn-link text-decoration-none fw-semibold text-muted mb-3"
                        >
                            Esqueceu sua senha de acesso? Toque aqui para recuperar
                        </button> */}
                        <Link to="/app/resetsenha" 
                            className="btn btn-link text-decoration-none fw-semibold text-muted mb-3"
                            value="Login">Esqueceu sua senha de acesso? Toque aqui para recuperar
                        </Link>

                        <div className="textoRodape">
                            {/* <button 
                                onClick={() => onNavigate('novaconta')} 
                                className="btn btn-outline-primary px-4 py-2 rounded-pill fw-semibold text-sm shadow-sm transition-all"
                            >
                                Não tenho conta. Toque aqui para criar uma agora.
                            </button> */}
                            <Link className="btn btn-outline-primary px-4 py-2 rounded-pill fw-semibold text-sm shadow-sm transition-all"
                                to="/app/novaconta">Não tenho conta. Toque aqui para criar uma agora.
                            </Link>
                            <p className="text-secondary mt-3 small">
                                Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
    export default Login;
